module.exports = __webpack_public_path__ + "zw.svg?98a0162ecab2b3730a13f37ed11ef6c3";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/zw.svg
// module id = 1231
// module chunks = 27